import { SubscriptionTracker } from 'src/app/shared/utilities/subscription-tracker';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent extends SubscriptionTracker implements OnInit {
  title = 'Request a Login';
  readonly isLocalMode = environment.apiUrl.includes('localhost')
    || environment.oktaIssuer.includes('localhost');

    constructor(private router: Router) {
        super();
    }

  ngOnInit(): void {
    this._track(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.title = event.urlAfterRedirects.includes('/registration') ? 'Request a Login' : this.title;
        }
      })
    );
  }
}
